import React, { type FC } from "react";

import PauseIcon from "../Icons/Pause";

const PauseEffect: FC = () => {
  return (
    <div className="tuby-fade-zoom-out tuby-effect-icon">
      <PauseIcon className="tuby-icon-md" />
    </div>
  );
};

export default PauseEffect;
